import { useEffect, useRef } from "react";
import { getAudio } from "@/audio";
import { makeBird, drawBird } from "@/birdsong";
import { startDawnUnzip } from "@/vessels";

const chirp = (ctx, dest, at) => {
  const f = 2600 + Math.random() * 1600;
  const notes = 2 + Math.floor(Math.random() * 4);
  for (let i = 0; i < notes; i++) {
    const t = at + i * (0.09 + Math.random() * 0.05);
    const o = ctx.createOscillator(), g = ctx.createGain();
    o.type = "sine";
    o.frequency.setValueAtTime(f * (0.9 + Math.random() * 0.2), t);
    o.frequency.exponentialRampToValueAtTime(f * (1.25 + Math.random() * 0.3), t + 0.05);
    o.frequency.exponentialRampToValueAtTime(f * 0.85, t + 0.09);
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(0.035, t + 0.015);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.1);
    o.connect(g).connect(dest);
    o.start(t);
    o.stop(t + 0.12);
  }
};

export const playDawnBirdsong = (seconds = 9) => {
  const { ctx, out } = getAudio();
  let t = ctx.currentTime + 0.4, count = 0;
  while (t < ctx.currentTime + seconds) {
    chirp(ctx, out, t);
    count++;
    t += 0.35 + Math.random() * 0.9;
  }
  window.__dawnChirps = (window.__dawnChirps || 0) + count;
};

const BirdChorus = () => {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current, ctx = c.getContext("2d");
    const w = (c.width = window.innerWidth), h = (c.height = window.innerHeight);
    const start = performance.now();
    const birds = Array.from({ length: 14 }, (_, i) => {
      const b = makeBird(w, h, -60 - Math.abs(i - 6.5) * 45 - Math.random() * 30);
      b.y = h * 0.42 + (i - 6.5) * h * 0.035 + (Math.random() - 0.5) * 30;
      b.vx = w / 520;
      return b;
    });
    window.__dawnBirds = birds.length;
    let raf;
    const loop = (now) => {
      const t = (now - start) / 1000;
      ctx.globalCompositeOperation = "source-over";
      ctx.clearRect(0, 0, w, h);
      birds.forEach((b) => {
        b.x += b.vx;
        b.y += Math.sin(t * 2 + b.ph) * 0.4 - 0.12;
        drawBird(ctx, b, t, true);
      });
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);
  return <canvas ref={ref} className="dawn-birds" data-testid="dawn-bird-chorus" aria-hidden="true" />;
};

export const DawnGlow = ({ onDone }) => {
  useEffect(() => {
    playDawnBirdsong();
    startDawnUnzip();
    const t = setTimeout(onDone, 12000);
    return () => clearTimeout(t);
  }, [onDone]);
  return (
    <div className="dawn-glow" data-testid="dawn-glow" aria-hidden="true">
      <BirdChorus />
    </div>
  );
};
